<template>
  <q-card class="updates-card col-4 gt-sm gt-xs no-border-radius">
    <q-card-section color="primary" class="text-center">
      <q-item-label class="title title-welcome">
        <translate>WELCOME</translate>
      </q-item-label>
      <q-item-label class="title title-system">
        <translate>WASTE</translate>
      </q-item-label>
    </q-card-section>
  </q-card>
</template>
<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import {
  QCard,
  QCardSection
} from 'quasar'

@Component({
  name: 'login-title',
  components: {
    QCard,
    QCardSection
  }
})
export default class LoginTitle extends Vue {
}
</script>
<style scoped>
.updates-card {
  background: rgba(255, 255, 255, 0.3);
  box-shadow: none;
  flex-grow: 2;
}

.title {
  flex: 1 1 100%;
  font: bold;
  color: #FFFFFF;
  text-shadow: 0px 3px 6px #00000029;
  opacity: 1;
  font-weight: 300;
  text-align: left;
}

.title-welcome {
  font-size: 1.1rem;
  margin: 35% 20px 0px;
}

.title-system {
  font-size: 1.9rem;
  margin: 10px 15% 45% 20px;
  font-weight: 500;
}

@media only screen and (max-width: 1090px) {
  .slogan {
    font-size: 0.8rem;
  }
}
</style>
